export default __webpack_public_path__ + "static/Flamethrower-94a7b02efd0ce7b04fc04753af77c27e.png";